import { Injectable } from "@angular/core";
import { KeystoneHttpClient } from "../../../keystone-http";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class UserHttpService {
  constructor(
    private authHttp: KeystoneHttpClient,
    private http: HttpClient
  ){ }

  get(id): Observable<any> {
    return this.authHttp.get(`users/${id}`).map(res => (res.user))
  }

  update(id: any, userFileds:any): Observable<any> {
    return this.authHttp.put(`users/${id}`, userFileds ).map(res => {
      return res.user
    })
  }

  updatePassword(id, token, password): Observable<any> {
    return this.http.post(this.authHttp.getBaseUrl() + '/resetPwd', {
      uid: id,
      token: token,
      password: password
    }).map(res => {
      return res;
    })
  }

  logout(user){
    return this.authHttp.post('logout', {
      uid : user._id
    }).map(res=>res);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/user/user-http.service.ts